<template lang="pug"></template>

<script>
import BotaoGestaoLotesPssc from '@/components/botoesMenu/BotaoGestaoLotesPssc';
import BotaoDashboardPssc from '@/components/botoesMenu/BotaoDashboardPssc';

export default {
    name: 'BotaoPSSC',
    componentOptions: {
        title: 'PSSC',
        actions: [
            [
                {
                    name: 'PSSC',
                    iconClass: 'lyra-icon lyra-pssc',
                    showView: false,
                    action: 'abrir',
                    route: 'PSSC',
                    submenus: [
                        BotaoGestaoLotesPssc,
                        BotaoDashboardPssc
                    ]
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'PSSC') {
                this.$router.push({ name: 'PSSC' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
